import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "quantity-selector" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "button-content" }, "+", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "button-content" }, "-", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "quantity-text" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Quantité : ")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" unité")
const _hoisted_11 = { key: 0 }

import { ID_ROULEAU, ID_VIS, IProduct, ID_U_DEPART_1, ID_U_DEPART_2 } from '@/model/Product';
import { ref } from '@vue/reactivity';
import { PropType, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  input: { type: Number as PropType<number | undefined>, default: () => undefined },
  accessoire: { type: Object as PropType<IProduct | undefined>, default: () => undefined },
},
  emits: ['updateQuantity', 'updateAmount'],
  setup(__props, { emit: emits }) {

const props = __props

const quantity = ref(0)
const amount = ref(0)




const increaseQuantity = () => {
  const quantityChange = getQuantity()
  quantity.value += quantityChange
  amount.value++
  emits('updateQuantity', quantity.value)
  emits('updateAmount', amount.value)
}

const decreaseQuantity = () => {
  if (quantity.value <= 0) return
  const quantityChange = getQuantity()
  quantity.value -= quantityChange
  amount.value--
  emits('updateQuantity', quantity.value)
  emits('updateAmount', amount.value)
}

const getQuantity = () => {
  const quantityChange = props.accessoire?.idp === ID_VIS ? 500 :
    props.accessoire?.idp === ID_ROULEAU ? 60 :
      props.accessoire?.idp === ID_U_DEPART_1 ? 6 :
        props.accessoire?.idp === ID_U_DEPART_2 ? 6 :
          +(props.accessoire?.conditionnement || 0)

  return quantityChange
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "button-quantity add",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (increaseQuantity()))
    }, _hoisted_3),
    _createElementVNode("button", {
      class: "button-quantity sub",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (decreaseQuantity()))
    }, _hoisted_5),
    _createElementVNode("span", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("strong", null, _toDisplayString(quantity.value), 1),
      (__props.accessoire?.condition_type === 'ml' || __props.accessoire?.idp === _unref(ID_ROULEAU) || __props.accessoire?.idp === _unref(ID_U_DEPART_1) || __props.accessoire?.idp === _unref(ID_U_DEPART_2))
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, " ml"))
        : (_openBlock(), _createElementBlock("span", _hoisted_9, [
            _hoisted_10,
            (quantity.value > 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "s"))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}
}

})